export default __webpack_public_path__ + "static/media/PI.1ffe36f9.svg";